import $ from 'jquery'

import 'select2'

import 'select2/dist/css/select2.css'

document.addEventListener('translationsLoaded', (e) => {

    if (
        window.location.pathname.includes("search") &&
        window.location.search !== ""
    ) {
        let queryparams = window.location.search.split("?")[1];
        let defaultLink = $(".btn.export").attr("href");
        $(".btn.export").attr("href", defaultLink + "?" + queryparams);
    }

    $(document).ready(function () {

        $(".js-example-basic-multiple").select2();

        $("[name='show-export']").on('change', function (e) {
            e.preventDefault()

            if ($(this).val() === 'show-date-export') {
                $('.form-group.inline.hide').css('display', 'inline-block')
            } else {
                $('.form-group.inline.hide').hide()
            }
        })

        $('#select-all').on('click', function (e) {

            if ($(this).is(":checked")) {
                $('.option-checkbox').each(function (index, el) {
                    $(this).attr('disabled', false)
                    $(this).prop('checked', true);
                })
            } else {
                $('.option-checkbox').each(function (index, el) {
                    $(this).prop('checked', false);
                    if ($(this).hasClass('child')) {
                        $(this).attr('disabled', true)
                    }
                })
            }

        })

        $('#export-report input[type="checkbox"].parent').on('click', function (e) {

            $(this).toggleClass('not-disabled');

            if ($(this).hasClass('not-disabled')) {
                $(this).parents('.form-group').find('.child').each(function (index, el) {
                    $(this).attr('disabled', false)
                })
            }

            else {
                $(this).parents('.form-group').find('.child').each(function (index, el) {
                    $(this).attr('disabled', true)
                })
            }

        });

        if ($('#checkout-form').length) {

            const clientSecret = document.getElementById('payment-card').dataset.secret;

            const elements = stripe.elements({ locale: document.documentElement.lang });

            const cardElement = elements.create('card');

            cardElement.mount('#payment-card');

            const form = document.getElementById('checkout-form');

            form.addEventListener('submit', function (event) {

                const submit = $(event.target).closest('form').find(':submit');

                submit.prop('disabled', true)

                $('#registration-card-error').hide();

                event.preventDefault();

                stripe.confirmCardSetup(clientSecret, { payment_method: { card: cardElement } }).then(function (result) {

                    if (result.error) {
                        $('#registration-card-error').show();
                        $('#registration-card-error-message').html(result.error.message);

                        submit.prop('disabled', false)

                    } else {

                        let input = document.createElement("input");

                        input.setAttribute('type', 'hidden');
                        input.setAttribute('name', 'payment_method');
                        input.setAttribute('value', result.setupIntent.payment_method);

                        form.appendChild(input);
                        form.submit()
                    }
                });

            });
        }

        if ($('body').hasClass('generate-project-report')) {
            $('#export-report-download').submit();
        }

        $('input.checkbox').on('click', function (e) {

            let checkBoxes = $('input.checkbox:checked')

            if (checkBoxes.length) {
                $('button.delete-multi').show()
            } else {
                $('button.delete-multi').hide()
            }

        })

        $('#select-all-answers').on('click', function (e) {

            let checkBoxes = $('input.checkbox');

            let imChecked = $(e.target).prop('checked')

            let prop = !checkBoxes.prop("checked");

            if ($('input.checkbox:checked').length && imChecked) {
                prop = true;
            }

            checkBoxes.prop("checked", prop);

            if ($('input.checkbox:checked').length) {
                $('button.delete-multi').show()
            } else {
                $('button.delete-multi').hide()
            }

        })

        const token = document.head.querySelector('meta[name="csrf-token"]').content

        const url = window.location.origin

        if (document.getElementById('text')) {

            CKEDITOR.replace('text', {
                filebrowserUploadUrl: url + '/admin/blogg/upload-wysiwyg?_token=' + token,
                filebrowserUploadMethod: 'form'
            });

        }

        if (document.getElementById('summary')) {

            CKEDITOR.replace('summary', {
                filebrowserUploadUrl: url + '/admin/blogg/upload-wysiwyg?_token=' + token,
                filebrowserUploadMethod: 'form'
            });

        }

    });

})




